export type Type = 'CHILD' | 'PARENT' | 'GLOBAL_PARENT';

export const TypeLabels: { [x in Type]: string } = {
  CHILD: 'プロセス',
  PARENT: '自団体のアンブレラ',
  GLOBAL_PARENT: '共通アンブレラ'
};

export const TypeKeys: { [x in Type]: x } = {
  CHILD: 'CHILD',
  PARENT: 'PARENT',
  GLOBAL_PARENT: 'GLOBAL_PARENT'
};
